<template>
  <div class="driver-controls">
    <div class="row">
      <div class="columns padding-R small-4">
        <a class="button cta small success block" href="javascript:;" @click="modal.show = true">SEND TO DRIVER</a>
      </div>
      <div class="small-4 columns padding-L padding-R">
        <a class="button cta small block" href="javascript:;" @click="assignToDriver">ASSIGN TO DRIVER</a>
        <!-- <a :class="{'button cta small success block':true, 'disabled':scheduleLoading}" href="javascript:;" @click="sendAsSchedule">
          <span v-if="scheduleLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> Loading...</span>
          <span v-else>SEND AS SCHEDULE</span>
        </a> -->
      </div>
      <div class="columns padding-L small-4">
        <a class="button cta small warning block" href="javascript:;" @click="sendAsAsap">SEND AS ASAP</a>
      </div>
    </div>
    <!-- <div class="row margin-T">
      <div class="small-12 columns">
        <a class="button cta small block" href="javascript:;" @click="assignToDriver">ASSIGN TO DRIVER</a>
      </div>
    </div> -->

    <div :class="['dispatch-modal', {show: modal.show}]" @click="close">
      <div class="dispatch-modal-container">
        <div class="dispatch-modal-content" @click.stop>
          <div class="validation-modal">
            <div class="title">Send to driver</div>
            <div class="message">Accept Request Timeout</div>
            <label class="option" @click="modal.option = 'default'">
              <input type="radio" name="crt" checked="checked" v-if="modal.show" />
              <span class="s">Default ({{$settings.get('ASAPRequestTimeout')}} sec)</span>
            </label>
            <label class="option" @click="modal.option = 'custom'">
              <input type="radio" name="crt" v-if="modal.show" />
              <div class="input-integer" style="display: inline-block">
                <input type="number" v-model="modal.custom" /> <span>secs</span>
              </div>
              <!-- <input type="text" v-model="modal.custom" /> -->
            </label>
            <div style="padding: 10px 50px;margin: 30px 0 10px;">
              <a class="button success block" href="javascript:;" @click="sendToDriver">Yes</a>
              <a class="cancel" href="javascript:;" @click="close">No, I change my mind</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'driver-controls',
  data () {
    return {
      scheduleTimer: '',
      runningSchedule: false,
      backup: [],
      modal: {
        show: false,
        option: 'default',
        custom: 60
      }
    }
  },
  computed: {
    // currentDispatchTab () { return this.$store.state.dispatch.currentTable },
    currentDispatchTab () { return 0 },
    scheduleLoading () { return this.$store.state.dispatch.schedule.loading }
  },
  methods: {
    isOnDuty (driverId) {
      let self = this
      let onDutyDrivers = self.$store.state.laxit.onDuty.list
      return onDutyDrivers.filter(onDuty => onDuty.id === driverId).length === 1
    },
    isStatusValid (items) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item.status === 'complete' ||
            item.status === 'completed' ||
            item.status === 'canceled' ||
            item.status === 'onboard' ||
            item.status === 'dispatched') {
          return false
        }
      }
      return true
    },
    sendToDriver () {
      let self = this
      this.modal.show = false

      let tncReservations = self.$store.state.laxit.tncReservations
      let checked = tncReservations.checked
      let driverId = self.$store.state.laxit.selectedDriver
      driverId = driverId.split('-')[0]

      // let laxit = self.$store.state.laxit
      // let tncReservations = laxit.tncReservations
      // let rsvps = laxit.tncReservations.checked
      // if (laxit.unroutedReservations.checked.length) {
      //   rsvps = laxit.unroutedReservations.checked
      // }
      // let checked = tncReservations.checked
      // let driverId = self.$store.state.laxit.selectedDriver

      if (driverId === null || checked.length <= 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation/package to proceed.'
        })
        return
      }

      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('laxit/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only send reservations/pacakges to on-duty drivers.'
      //   })
      //   return
      // }

      let index = tncReservations.list.findIndex(x => x.id === checked[0])
      let selected = tncReservations.list[index]

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        })
        return
      }

      let url = selected.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/'
      self.$store.commit('laxit/showActionModal',
        'Sending' +  (selected.type === 'rsvp' ? ' reservation ' : ' package ') + 'to driver...')

      let customRequestTimeout = self.$settings.get('ASAPRequestTimeout')
      if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom
      self.$sdk.post(url + selected.id + '/send', {
        token: self.$store.state.session.sessionToken,
        provId: driverId,
        customRequestTimeout: customRequestTimeout
      }, r => {
        if (r.error) {
          self.$store.commit('laxit/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('laxit/setTncReservationsChecked', [])
          self.$store.commit('laxit/removeUnroutedReservation')
          // self.$store.commit('dispatch/setSelectedDriver', null) // TODO
          self.$store.commit('laxit/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation.'
          })
        }

        setTimeout ( () => {
          self.$store.commit('laxit/closeActionModal')
        }, 3000)
      })
    },
    sendAsSchedule () {
      let self = this
      let laxit = self.$store.state.laxit
      let routing = self.$store.state.routing

      let rsvps = []
      let pkgs = []
      let driverId = laxit.selectedDriver
      driverId = driverId.split('-')[0]
      let notAllowed = false

      // Dispatch table
      if (self.currentDispatchTab === 0) {
        if (laxit.tncReservations.checked.length) {
          dispatch.checkedReservations.forEach (function (data) {
            if (['upcoming', 'requires-dispatch'].indexOf(data.status) < 0) {
              notAllowed = true
              return false
            }
            if (data.isPackage) { pkgs.push(data.id) }
            else { rsvps.push(data.id) }
          })
        }
      }

      // Routing table - Packages
      if (self.currentDispatchTab === 1) {
        pkgs = routing.packages.checkedForDispatch
        routing.packages.items.forEach (function (data) {
          if (pkgs.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true
          }
        })
      }

      // Routing table - Unpackages
      if (self.currentDispatchTab === 2) {
        rsvps = routing.reservations.checked
        routing.reservations.items.forEach (function (data) {
          if (rsvps.indexOf(data.id) > -1 && ['upcoming', 'requires-dispatch'].indexOf(data.statusClass) < 0) {
            notAllowed = true
          }
        })
      }

      if (notAllowed) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Not Allowed',
          message: 'Only UPCOMING and REQUIRES DISPATCH reservations/packages are allowed to be schedule.'
        })
        return
      }

      let totalSelected = rsvps.length + pkgs.length
      if (driverId === null || totalSelected <= 1) {
        self.$store.commit('dispatch/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 2 reservations/packages to proceed.'
        })
        return
      }

      self.scheduleTimer = ''
      self.runningSchedule = false
      self.$store.commit('dispatch/setScheduleAccepted', false)
      self.$store.commit('dispatch/setScheduleShow', true)
      self.$store.commit('dispatch/setScheduleLoading', true)
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Setting schedule. Please wait...')

      self.$store.commit('dispatch/setScheduleRsvp', rsvps)
      self.$store.commit('dispatch/setSchedulePkg', pkgs)
      let driverList = 'onDuty'
      if (self.$store.state.dispatch.driverListTabIndex === 1) { driverList = 'staging' }
      if (self.$store.state.dispatch.driverListTabIndex === 2) { driverList = 'offDuty' }
      let driverIndex = self.$store.state.dispatch[driverList].drivers.findIndex(x => x.id === driverId)
      let driver = self.$store.state.dispatch[driverList].drivers[driverIndex]
      self.$store.commit('dispatch/setScheduleDriverData', {
        id: driverId,
        name: driver.firstName + ' ' + driver.lastName
      })

      self.backup = []
      self.backup = self.$store.state.dispatch.rsvpInTable

      dispatch.checkedReservations.forEach (function (data) {
        self.$store.commit('dispatch/removeRsvpInTable', data)
      })

      self.$sdk.post('/admin/schedule/', {
        token: self.$store.state.session.sessionToken,
        provID: driverId,
        reservationIDs: rsvps,
        packageIDs: pkgs
      }, r => {
        self.$store.commit('dispatch/setScheduleLoading', false)
        if (r.error) {
          // self.$store.commit('dispatch/setScheduleShow', false)
          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Oops. Something went wrong.',
          //   message: r.error.message
          // })

          self.$store.commit('dispatch/setScheduleError', r.error.message)
          self.$store.commit('dispatch/setRsvpInTable', self.backup)
          return
        }

        self.runningSchedule = true
        self.scheduleTimer = setTimeout(function () {
          self.runningSchedule = false
          if (!self.$store.state.dispatch.schedule.accepted) {
            self.$store.commit('dispatch/setScheduleShow', false)
            // self.$store.commit('dispatch/showValidationModal', {
            //   title: 'Failed',
            //   message: 'The Driver seems to be busy at the moment. Try again later.'
            // })

            self.$store.commit('dispatch/showDispatchAcceptNotification', {
              show: true,
              accept: false,
              isPackage: false,
              id: null,
              driverId: null,
              driverName: '',
              isSendAsSchedule: true,
              sendAsScheduleError: 'The Driver seems to be busy at the moment. Try again later.',
              runsDeclined: false
            })
          }
        }, 180000) // 3 mins
        self.getSchedule(r)
      })
    },
    getSchedule (data) {
      let self = this
      self.$store.commit('dispatch/setScheduleLoading', true)
      self.$store.commit('dispatch/setScheduleLoadingMsg', 'Pending Driver. Please wait...')
      self.$store.commit('dispatch/setScheduleShow', false) // Hide Modal Early

      self.$sdk.get('/admin/schedule/' + data.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/setScheduleShow', false)
          self.$store.commit('dispatch/showValidationModal', {
            title: 'Oops. Something went wrong.',
            message: r.error.message
          })

          self.runningSchedule = false
          if (self.scheduleTimer) { clearTimeout(self.scheduleTimer) }
          return
        }

        let scheduleStore = self.$store.state.dispatch.schedule
        if (r.status === 'pending') {
          if (self.runningSchedule) {
            setTimeout(function () {
              self.getSchedule(data)
            }, 5000)
          }
        } else if (r.status === 'accepted') {
          self.runningSchedule = false
          if (self.scheduleTimer) { clearTimeout(self.scheduleTimer) }
          self.$store.commit('dispatch/setScheduleLoading', false)
          self.$store.commit('dispatch/setScheduleAccepted', true)

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: true,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          })
        } else if (r.status === 'rejected') {
          self.runningSchedule = false
          if (self.scheduleTimer) { clearTimeout(self.scheduleTimer) }
          self.$store.commit('dispatch/setScheduleShow', false)
          self.$store.commit('dispatch/setScheduleLoading', false)

          // self.$store.commit('dispatch/showValidationModal', {
          //   title: 'Rejected',
          //   message: 'Schedule reservation/package was rejected by the driver'
          // })

          self.$store.commit('dispatch/showDispatchAcceptNotification', {
            show: true,
            accept: false,
            isPackage: false,
            id: null,
            driverId: scheduleStore.driverData.id,
            driverName: scheduleStore.driverData.name,
            isSendAsSchedule: true,
            sendAsScheduleError: '',
            runsDeclined: false
          })
        }

      })
    },
    sendAsAsap () {
      let self = this
      let tncReservations = self.$store.state.laxit.tncReservations
      let checked = tncReservations.checked
      let driverId = self.$store.state.laxit.selectedDriver
      driverId = driverId.split('-')[0]

      if (driverId === null || checked.length <= 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and only 1 reservation to proceed.'
        })
        return false
      }

      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('laxit/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only send reservations to on-duty drivers.'
      //   })
      //   return
      // }

      let index = tncReservations.list.findIndex(x => x.id === checked[0])
      let selected = tncReservations.list[index]

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only send Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        })
        return
      }
      let url = selected.type === 'rsvp' ? '/admin/rsvp/' : '/admin/package/'
      self.$store.commit('laxit/showActionModal',
        'Sending' +  (selected.type === 'rsvp' ? ' reservation ' : ' package ') + 'to driver as asap...')

      self.$sdk.post(url + selected.id + '/asap', {
        token: self.$store.state.session.sessionToken,
        provId: driverId
      }, r => {
        if (r.error) {
          self.$store.commit('laxit/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('laxit/removeTncReservationsChecked')
          self.$store.commit('laxit/setSelectedDriver', null)
          self.$store.commit('laxit/completeActionModal', {
            success: true,
            message: 'Successfully sent reservation as asap.'
          })
        }

        setTimeout ( () => {
          self.$store.commit('laxit/closeActionModal')
        }, 3000)
      })
    },
    assignToDriver () {
      let self = this
      let tncReservations = self.$store.state.laxit.tncReservations
      let checked = tncReservations.checked
      let driverId = self.$store.state.laxit.selectedDriver
      driverId = driverId.split('-')[0]

      // let rsvps = self.$store.state.laxit.checkedReservations
      // if (self.$store.state.routing.packages.checkedForDispatch.length > 0) {
      //   rsvps = []
      //   rsvps.push({
      //     isPackage: true,
      //     id: self.$store.state.routing.packages.checkedForDispatch[0]
      //   })
      // }
      // let driverId = self.$store.state.dispatch.selectedDriver

      if (driverId === null || checked.length === 0 || checked.length > 1) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'Please select 1 driver and at least 1 reservation or package to proceed.'
        })
        return false
      }
      // if (!self.isOnDuty(driverId)) {
      //   self.$store.commit('dispatch/showValidationModal', {
      //     title: 'Oops. You missed something.',
      //     message: 'You can only assign reservations and/or packages to on-duty drivers.'
      //   })
      //   return
      // }

      let index = tncReservations.list.findIndex(x => x.id === checked[0])
      let selected = tncReservations.list[index]

      if (!self.isStatusValid(selected)) {
        self.$store.commit('laxit/showValidationModal', {
          title: 'Oops. You missed something.',
          message: 'You can only assign Upcoming, Requires Dispatch and Ready to Go reservations/packages to drivers.'
        })
        return
      }

      let requests = self.getAssignRequest(selected)
      if (requests.length <= 0) {
        return
      }

      self.$store.commit('laxit/showActionModal', 'Assigning items to driver...')
      self.$sdk.post('/provider/' + driverId + '/assign', requests[0], r => {
        if (requests.length > 1) {
          self.$sdk.post('/provider/' + driverId + '/assign', requests[1], r => {
            if (r.results && Array.isArray(r.results) &&
                r.results.length > 0 && r.results[0].error) {
              let error = r.results[0].error
              self.$store.commit('laxit/completeActionModal', {
                success: false,
                message: error.message ? error.message : 'Something went wrong.'
              })
            } else {
              self.$store.commit('laxit/completeActionModal', {
                success: true,
                message: 'Successfully assigned items to driver.'
              })
            }
            setTimeout ( () => {
              self.$store.commit('laxit/closeActionModal')
            }, 3000)
          })
        } else {
          if (r.results && Array.isArray(r.results) &&
              r.results.length > 0 && r.results[0].error) {
            let error = r.results[0].error
            console.log(r)
            self.$store.commit('laxit/completeActionModal', {
              success: false,
              message: error.message ? error.message : 'Something went wrong.'
            })
          } else {
            self.$store.commit('laxit/completeActionModal', {
              success: true,
              message: 'Successfully assigned items to driver.'
            })
          }
          setTimeout ( () => {
            self.$store.commit('laxit/closeActionModal')
          }, 3000)
        }
      })
    },
    getAssignRequest (items) {
      let self = this

      let rsvpIds = []
      let packageIds = []
      if (items.type === 'package') {
        packageIds.push(items.id)
      } else {
        rsvpIds.push(items.id)
      }

      let token = self.$store.state.session.sessionToken

      let results = []
      if (rsvpIds.length > 0) {
        results.push({
          token: token,
          rsvpId: rsvpIds
        })
      }
      if (packageIds.length > 0) {
        results.push({
          token: token,
          packageId: packageIds
        })
      }
      return results
    },
    close () {
      this.modal.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.driver-controls{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 15px;
  background-color: #3a3a3a;
  border-left: 1px solid rgba(0,0,0,0.2);
  border-right: 1px solid rgba(0,0,0,0.2);
  border-top: 1px solid rgba(0,0,0,0.2);
}

.padding-R { padding-right: 5px; }
.padding-L { padding-left: 5px; }
.margin-T { margin-top: 10px; }


.dispatch-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }

  .option{
    display: block;
    width: 300px;
    margin:0 auto;
    text-align: left;

    input[type=radio]{
      width: auto;
      display: inline-block;
      margin-right: 5px;
      margin-top: 0;
    }
    span.s{
      display: inline-block;
      font-size: 14px;
      color: #444;
    }
  }
}

.dispatch-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.dispatch-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
}

.validation-modal {
  & .title{
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background-color: #F25E0D;
    padding: 8px 15px;
  }

  & .message{
    font-size: 16px;
    font-weight: 700;
    color: #555;
    padding: 15px 15px 10px;
  }

  & .button{
    font-weight: 700;
  }
  .cancel{
    margin-top: 10px;
    color: #999;
    display: inline-block;
  }
}

.action-modal{
  padding: 15px;
  & .message{
    font-weight: 700;
    color: #777;
    transition: all 250ms;

    &.success{ color: #26D97A; }
    &.error{ color: #F20D0D; }
  }
}

// Define vars we'll be using
$brand-success: #26D97A;
$loader-size: 50px;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$error-left: $loader-size/4;
$check-thickness: 5px;
$check-color: $brand-success;
$error-color: #F20D0D;

.circle-loader {
  margin: 0 0 10px 10px;
  border: $check-thickness solid rgba(0, 0, 0, 0.2);
  border-left-color: $check-color;
  animation-name: loader-spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  box-sizing: content-box;
}

.circle-loader,
.circle-loader:after {
  border-radius: 50%;
  width: $loader-size;
  height: $loader-size;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: $check-color;
  transition: border 500ms ease-out;
}
.load-error {
  -webkit-animation: none;
  animation: none;
  border-color: $error-color;
  transition: border 500ms ease-out;
}

.checkmark {
  opacity: 0;
  box-sizing: content-box;
  &.draw{ opacity: 1; }
  &.draw:after {
    opacity: 1;
    height: $check-height;
    width: $check-width;
    transform-origin: left top;
    border-right: $check-thickness solid $check-color;
    border-top: $check-thickness solid $check-color;
    content: '';
    left: calc(#{$check-left} - 5px);
    top: calc(#{$check-height} + 2px);
    position: absolute;
    animation-duration: 1.2s;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }
  
  &.error {
    position: absolute;
    left: calc(#{$error-left} - 2px);
    top: $error-left;
    width: $loader-size/2;
    height: $loader-size/2;
    opacity: 0;
    &.show{ opacity: 1; }
    &:before, &:after {
      position: absolute;
      content: ' ';
      height: $loader-size/2;
      width: 5px;
      background-color: #f00;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

}
@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
}
.input-integer > * {
  display: inline-block;
  vertical-align: middle;
  margin-top: 5px;
}
input[type="number"] {
  font-size: 14px;
  padding: 7px 10px;
  display: inline-block;
  width: 200px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-integer span {
  font-size: 12px;
  background-color: #555;
  color: #fff;
  padding: 9px 10px 10px;
  margin-left: -5px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/DriverControls.vue